// WhatsApp Business API integration mock
// Replace with actual WhatsApp Business API when backend is connected

export interface WhatsAppConfig {
  businessId: string;
  apiKey: string;
  webhookUrl: string;
}

export const whatsappService = {
  generateCheckoutLink: (orderId: string, amount: number): string => {
    // Generate a unique checkout link for WhatsApp
    const baseUrl = window.location.origin;
    const sessionToken = crypto.randomUUID();
    return `${baseUrl}/checkout/${orderId}?token=${sessionToken}&amount=${amount}`;
  },
  
  sendCheckoutMessage: async (phoneNumber: string, checkoutLink: string, orderDetails: any) => {
    // Mock sending WhatsApp message
    const message = `🛒 *Your SocialCart Order*\n\n` +
      `Items: ${orderDetails.items.length}\n` +
      `Total: ${orderDetails.currency} ${orderDetails.totalAmount}\n\n` +
      `Complete your purchase: ${checkoutLink}\n\n` +
      `This link expires in 30 minutes.`;
    
    console.log('Sending WhatsApp message to:', phoneNumber);
    console.log('Message:', message);
    
    // In production, this would call the WhatsApp Business API
    return {
      success: true,
      messageId: crypto.randomUUID(),
      timestamp: new Date(),
    };
  },
  
  sendOrderConfirmation: async (phoneNumber: string, orderId: string) => {
    const message = `✅ *Order Confirmed!*\n\n` +
      `Order ID: ${orderId}\n` +
      `We'll notify you when your order ships.\n\n` +
      `Track your order: ${window.location.origin}/orders/${orderId}`;
    
    console.log('Sending confirmation to:', phoneNumber);
    console.log('Message:', message);
    
    return {
      success: true,
      messageId: crypto.randomUUID(),
      timestamp: new Date(),
    };
  },
  
  formatWhatsAppUrl: (phoneNumber: string, text?: string): string => {
    // Format phone number (remove any non-numeric characters)
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    
    // Create WhatsApp URL
    const baseUrl = 'https://wa.me/';
    const url = text 
      ? `${baseUrl}${cleanNumber}?text=${encodeURIComponent(text)}`
      : `${baseUrl}${cleanNumber}`;
    
    return url;
  },
  
  formatWhatsAppStatusUrl: (text: string): string => {
    // Create WhatsApp Web URL for sharing to status
    return `https://web.whatsapp.com/send?text=${encodeURIComponent(text)}`;
  },
  
  validatePhoneNumber: (phoneNumber: string): boolean => {
    // Basic phone number validation
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    return cleanNumber.length >= 10 && cleanNumber.length <= 15;
  }
};